import { Segmented, SegmentedProps } from 'antd';
import classNames from 'classnames';
import './styles.scss';

type IPropsSegmentedGroup = Omit<SegmentedProps, 'ref'>;

/**
 * Renders the segmented sub-tab control used by the devices tables. Wraps antd's Segmented with the segmented-group class merged onto any caller class, defaulting size to large and forwarding the remaining props.
 *
 * @param className - Extra class merged onto the control.
 * @param size - Control size, large by default.
 * @param rest - Remaining Segmented props, including options and value.
 * @returns The segmented control markup.
 */
const SegmentedGroup = ({ className, size = 'large', ...rest }: IPropsSegmentedGroup) => (
  <Segmented className={classNames('segmented-group', className)} size={size} {...rest} />
);

export default SegmentedGroup;
